import React from 'react';
import AccessWrapper from '../Dashboard/DashboardTabs/AccessWrapper';

const FeatureToggle = ({
  features,
  feature,
  children,
  fallback = null,
  checkRole = false,
}: any) => {
  if (features[feature]) {
    // check for role based permissions
    if (checkRole) {
      return (
        <AccessWrapper feature={feature} fallback={fallback}>
          {children}
        </AccessWrapper>
      );
    }
    return children;
  }
  return fallback;
};

export default FeatureToggle;
